<template>
  <div class="relative overflow-hidden bg-gradient-to-r from-[#006086] to-[#004d6b]">
    <!-- Decorative background -->
    <div class="absolute inset-0">
      <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
        <path class="text-[#004d6b] text-opacity-40" fill="currentColor"
          d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
        <path class="text-[#003d56] text-opacity-40" fill="currentColor"
          d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
      </svg>
    </div>

    <div class="relative max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
      <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
        <div class="animate-fadeIn">
          <h2 class="text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            <span class="block">Pronto para transformar</span>
            <span class="block bg-clip-text text-transparent bg-gradient-to-r from-[#e6f0f4] to-[#007ba8]">sua
              empresa?</span>
          </h2>
          <p class="mt-4 text-lg text-[#e6f0f4] max-w-3xl">
            Comece agora mesmo com uma demonstração gratuita e descubra como a
            Kali Sistemas pode impulsionar seu negócio.
          </p>
        </div>
        <div class="mt-12 lg:mt-0">
          <div class="space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-4 lg:gap-6">
            <a v-if="activationHref" :href="activationHref" target="_blank" rel="noopener noreferrer"
              class="animate-slideUp flex items-center justify-center px-6 py-4 border-2 border-white text-xl font-medium rounded-xl text-[#006086] bg-white hover:bg-[#e6f0f4] transition-colors duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-transform pointer-events-auto">
              {{ activationLabel }}
            </a>
            <button v-else type="button" @click="openScheduleDemo"
              class="animate-slideUp flex items-center justify-center px-6 py-4 border-2 border-white text-xl font-medium rounded-xl text-[#006086] bg-white hover:bg-[#e6f0f4] transition-colors duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-transform pointer-events-auto">
              Agendar Demo
            </button>
            <button type="button" @click="openConsultorModal"
              class="animate-slideUp delay-200 flex items-center justify-center px-6 py-4 border-2 border-[#007ba8] text-xl font-medium rounded-xl text-white hover:bg-[#004d6b] transition-colors duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-transform pointer-events-auto">
              Falar com Consultor
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  activationHref: {
    type: String,
    default: "",
  },
  activationLabel: {
    type: String,
    default: "Solicitar ativação",
  },
});

// ── Agendar Demo ──────────────────────────────────────────────
const openScheduleDemo = () => {
  window.dispatchEvent(new CustomEvent("open-demo-modal"));
};

// ── Falar com Consultor ──────────────────────────────────────
// O modal em si é global (ConsultorModal.vue, montado no App.vue) para
// que o FAQ de qualquer página consiga abri-lo mesmo sem o <CTA/> por perto.
const openConsultorModal = () => {
  window.dispatchEvent(new CustomEvent("open-consultor-modal"));
};
</script>
